import { takeLatest, put, all, call } from "redux-saga/effects";
import analytics from "@services/analytics";
import {
  getProductDetails,
  getProductsBySearch,
  getAllProductRequests,
  getAllOosSkus,
} from "@services/api";
import { getProductByCategory } from "@services/cmsV2-api";
import {
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_REQUEST,
  GET_PRODUCT_DETAILS_REQUEST,
  GET_PRODUCT_DETAILS_SUCCESS,
  GET_SEARCHED_PRODUCTS_REQUEST,
  GET_SEARCHED_PRODUCTS_SUCCESS,
  FETCH_REQUEST_FOR_PRODUCT_REQUEST,
  FETCH_REQUEST_FOR_PRODUCT_SUCCESS,
  GET_OOS_SKUS_REQUEST,
  GET_OOS_SKUS_SUCCESS,
} from "../reducers/actionTypes";

import { store } from "../store";

import emitter from "../Event";
import {
  VIEW_CATEGORY_PRODUCTS,
  VIEW_REQUESTED_PRODUCTS,
} from "../constants/analyticsEvents";

function* getProductsByCategory(params) {
  try {
    const previousProduct = store.getState() && store.getState().products;
    const { productList = {} } = previousProduct;
    const { payload = "" } = params;
    const {
      catName = "",
      offsetValue = 10,
      limit = 10,
      fromScreen = "",
      category = {},
      replace = false,
    } = payload;
    const {
      category_id = "",
      category_name_en = "",
      category_url = "",
    } = category;
    const urlParam = `${catName}?limit=${limit}&offset=${offsetValue}`;
    const { data } = yield call(getProductByCategory, urlParam);
    const previousProductByCatogory = productList[catName] || [];

    const num_items_loaded = [...previousProductByCatogory, ...data.result]
      .length;

    let productsToBeStored = [...previousProductByCatogory, ...data.result];

    if (replace) {
      productsToBeStored = data.result;
    }

    yield put({
      type: GET_PRODUCT_SUCCESS,
      products: {
        [catName && catName.split(" ").join("")]: productsToBeStored,
      },
      productCount: { [catName && catName.split(" ").join("")]: data.count },
      offset: { [catName && catName.split(" ").join("")]: +offsetValue },
    });

    // analytics.trackEvent(VIEW_CATEGORY_PRODUCTS, {
    //   category_id,
    //   category_name_en,
    //   category_url,
    //   num_items_loaded,
    //   offset: offsetValue,
    //   screen: fromScreen,
    // });

    emitter.emit("fetchedProduct", true);
  } catch (error) {
    console.log(error);
  }
}

function* getSingleProductDetails(params) {
  try {
    const { payload = "" } = params;
    const { data } = yield call(getProductDetails, payload);
    yield put({
      type: GET_PRODUCT_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
  }
}

function* getSearchProducts(action) {
  try {
    const { searchTerm } = action;
    const { data } = yield call(getProductsBySearch, searchTerm);

    yield put({
      type: GET_SEARCHED_PRODUCTS_SUCCESS,
      products: data,
    });
  } catch (error) {
    console.log(error);
  }
}

function* fetchProductRequests(action) {
  try {
    const { data } = yield call(getAllProductRequests);

    // analytics.trackEvent(VIEW_REQUESTED_PRODUCTS, {
    //   num_items_requested: data && data.length,
    // });

    yield put({
      type: FETCH_REQUEST_FOR_PRODUCT_SUCCESS,
      productRequests: data,
    });
  } catch (error) {
    console.log(error);
  }
}

function* fetchOosSkyus() {
  try {
    const { data } = yield call(getAllOosSkus);
    yield put({
      type: GET_OOS_SKUS_SUCCESS,
      payload: data.result || [],
    });
  } catch (e) {
    console.log(e);
  }
}

export default function* root() {
  yield all([
    takeLatest(GET_PRODUCT_REQUEST, getProductsByCategory),
    takeLatest(GET_PRODUCT_DETAILS_REQUEST, getSingleProductDetails),
    takeLatest(GET_SEARCHED_PRODUCTS_REQUEST, getSearchProducts),
    takeLatest(FETCH_REQUEST_FOR_PRODUCT_REQUEST, fetchProductRequests),
    takeLatest(GET_OOS_SKUS_REQUEST, fetchOosSkyus),
  ]);
}
